import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { useSellersVtexContext } from 'pages/logistica/sellers-vetex/contexts';
import { SellerVtex } from 'pages/logistica/sellers-vetex/types';

export function useQuerySellersVtex() {
    const requestListagem = useRequestListagem();
    const { page, limit, sort, filter, autoLoad } = useListagemContext();
    const { setSellersVtex } = useSellersVtexContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/seller',
        sort: sort.length ? sort : [{ property: 'idSeller', direction: 'DESC' }],
        nested: true,
        filter,
        page,
        limit,
    };

    return useQuery<RequestListagem<SellerVtex[]>>({
        queryKey: ['sellers-vtex', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((response) => response.data),
        enabled: autoLoad,
        onSuccess: (data) => setSellersVtex(data.data),
        onError: () => setSellersVtex([]),
    });
}
